<template>
	<teleport to='#modals-centered-overlay-teleport'>
		<div
		class="popups-modal-wrapper"
        :class="{'mobile': getMobileAppState}"
		v-touch:swipe.left="nextHandler"
        v-touch:swipe.right="backHandler">
            <div class="popup-modal">
                <div class="modal-content-wrapper" :key="displaying">
                    <!-- PopUp Modal -->
                    <modal-centered-pop-up
                    :key="displaying"
                    :popUpInfo="getPopupsList[displaying]"
                    @closePopUps="handlePopUpClose"
                    @addDismissArray="handleAddDismissArray"
                    @removeDismissArray="handleRemoveDismissArray"/>
                </div>
                <!-- Circles to visually see our position in slider -->
                <navigation-circles-wrapper
                v-if="getPopupsList.length > 1 && getMobileAppState"
                :listLength="getPopupsList.length"
                :circleIndex="index"
                :selectedIndex="displaying"/>
                <!-- Web popups counter+navigation -->
                <div v-if="getPopupsList.length > 1" class="counter-navigation-wrapper">
                    <div v-if="!getMobileAppState" class="counter">{{`${displaying+1}/${getPopupsList.length}`}}</div>
                    <div class="buttons-wrapper">
                        <!-- Previous Buttons -->
                        <button-tertiary
                        v-if="displaying !== 0"
                        buttonSize="small"
                        :label="t('modals.popups.back')"
                        @clicked="backHandler"/>
                        <!-- Next Button -->
                        <button-secondary
                        buttonSize="small"
                        :label="secondaryButtonLabel"
                        @clicked="nextHandler"/>
                    </div>
                </div>
            </div>
			<!-- Loader -->
			<loader-generic v-if="showLoader" isOverlay/>
		</div>
	</teleport>
</template>

<script setup>
import ModalCenteredPopUp from '@/components/generic/modals/centered/popUps/PopUpModal'
import NavigationCirclesWrapper from '@/components/generic/sliders/navigation/CirclesWrapper.vue'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
import ButtonSecondary from '@/components/generic/buttons/Secondary'

/* Vue  */
import { ref, computed } from 'vue'

/* Store */
import { mapActions, mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const { requestDismissPopups, clearPopUpList } = mapActions(moduleMapper.SESSION)
const { getPopupsList } = mapGetters(moduleMapper.SESSION)
const { getMobileAppState } = mapGetters()

/*************************************************
*                                                *
*                     Aux Data                   *
*                                                *
*************************************************/
const showLoader = ref(false)
const displaying = ref(0)
const dismissArray = ref([])

const secondaryButtonLabel = computed(() => {
    return displaying.value === getPopupsList.value.length - 1 ? t('modals.popups.finish') : t('modals.popups.next')
})

const backHandler = () => {
    if (displaying.value === 0) displaying.value = getPopupsList.value.length - 1
	else displaying.value--
}

const nextHandler = () => {
    if (displaying.value === getPopupsList.value.length - 1) handlePopUpClose()
    else displaying.value++
}

const handleAddDismissArray = $event => {
	dismissArray.value.push($event)
}

const handleRemoveDismissArray = $event => {
	dismissArray.value = dismissArray.value.filter(value => value !== $event)
}

const handlePopUpClose = () => {
	requestDismissPopups({ popUpIds: dismissArray.value })
	clearPopUpList()
}

</script>

<style lang="scss">
.popups-modal-wrapper {
	@include modalsCenteredOverlayTeleportStyles;
    @include overlayBaseAnimation;

	width: 100%;
	height: 100%;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

    overflow: auto;

    .popup-modal {
        width: 448px;
        max-width: calc(100% - 32px);
        padding: 24px;

        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        border-radius: 8px;
        background-color: var(--secondary-light-4);
        box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.16);

        .modal-content-wrapper {
            width: 100%;
            height: auto;

            display: flex;
            flex-direction: column;
            justify-content: flex-start;

            opacity: 1;
            transition: all .5s ease-in-out;

            &.fade-animation-leave-active, &.fade-animation-enter {
                opacity: 0;
            }

            &.fade-animation-active, &.fade-animation-leave {
                opacity: 1;
            }
        }

        .counter-navigation-wrapper {
            width: 100%;
            height: auto;
            margin-top: 24px;

            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .counter {
                @include H7-Medium;

                color: var(--secondary);
            }

            .buttons-wrapper {
                width: auto;

                display: flex;
                gap: 16px;
            }
        }

        .circles-wrapper {
            margin-top: 24px;

            position: relative;
        }
    }

    &.mobile {
        .popup-modal {
            padding: 16px;

            .buttons-wrapper {
                width: 100%;
                justify-content: end;

                .button-secondary, .tertiary-button-wrapper {
                    width: 50%;
                }
            }
        }
    }
}

</style>
